import { createEffect, createEvent, createStore, sample } from 'effector';

interface ImageViewerSlide {
  src: string;
  title?: string;
  description?: string;
}
export interface ImageViewerState {
  open: boolean;
  index: number;
  slides: ImageViewerSlide[];
}

export const initialImageViewerState: ImageViewerState = {
  open: false,
  index: 0,
  slides: [],
};

export const $imageViewer = createStore(initialImageViewerState);

export const closeImageViewerEvent = createEvent();

export const openImageViewerEvent = createEvent<ImageViewerSlide>();

$imageViewer.on(closeImageViewerEvent, () => {
  return initialImageViewerState;
});

$imageViewer.on(openImageViewerEvent, (_, payload) => {
  return {
    open: true,
    index: 0,
    slides: [payload],
  };
});

const closeImageViewerFx = createEffect(() => {
  const pathname = window.location.pathname;
  const search = window.location.search;
  const isGlobalId = search.match(/^\?globalId=/);
  let url = '';
  if (pathname === '/files-dashboard' && isGlobalId) {
    url = '/files-dashboard';
  }
  if (pathname.match(/^\/space\/(.*?)\/files/) && isGlobalId) {
    url = pathname.replace(/\/files\?globalId=(.*)/, '/files');
  }
  url && window.history.pushState({}, '', url);
});

sample({
  source: $imageViewer,
  clock: closeImageViewerEvent,
  target: closeImageViewerFx,
});
